import { IModelOption, ISceneOption, ISceneMode, ISelectSceneAndMode, SceneConstType } from '@/store/modules/ModuleApp';
import { EventBusEnum, getLocalStorage, busEvent, setLocalStorage } from '@tencent/s2-client-vue-lib';
import Cookies from 'js-cookie';
import { userModule } from '@/store/modules/ModuleUser';

/**
 * 首页controller
 *
 * @export
 * @class IndexController
 */
export class IndexController {
	/** 用户选择历史列表 */
	public static USER_SELECTED_HISTORY: string = 'user-selected-history-newly';

	/** 当前用户选择场景列表 */
	public static CURRENT_SELECTED_SCENT_MODEL: string = 'user-selected-scene-model-newly';

	/**
	 * 获取COOKIE用户信息
	 *
	 * @returns {string}
	 *
	 * @memberOf IndexController
	 */
	public getCookieUserName(): string {
		return userModule.userData.id;
	}

	/** 获取用户维度KEY */
	public getUserHistoryKey(key: string = IndexController.USER_SELECTED_HISTORY): string {
		return `${this.getCookieUserName() || 'nobody'}-${key}`;
	}

	/** 获取用户维度KEY */
	public getUserCurrentSelectKey(key: string = IndexController.CURRENT_SELECTED_SCENT_MODEL): string {
		return `${this.getCookieUserName() || 'nobody'}-${key}`;
	}

	/** 保存用户选择内容入场景 */
	public saveUserSelect(sceneCode: string | undefined, modelCode: string | undefined, businessLine: string | undefined = ''): void {
		busEvent.$emit(EventBusEnum.APPS_SCENE_UPDATE, {
			userData: {
				id: this.getCookieUserName()
			},
			sceneData: {
				scene: sceneCode,
				model: modelCode,
				businessLine
			}
		});
	}

	/** 保存用户选择记录 */
	public saveUserSelectedHistory(sceneSelectData: ISceneOption | undefined, modelSelectData: IModelOption | undefined): void {
		// 获取用户记录
		const historyList: Array<ISceneMode> = getLocalStorage(this.getUserHistoryKey()) || [];
		if (historyList) {
			const insertItem: ISceneMode = {
				scene: sceneSelectData?.sceneCode || SceneConstType.SCENE_QCP,
				model: modelSelectData?.modelCode || SceneConstType.MODEL_CDP
			};
			let isInList: boolean = false;
			const fileterList: Array<ISceneMode> = historyList.filter((item: ISceneMode): any => {
				if (item.model !== insertItem.model && item.scene !== insertItem.scene) {
					return true;
				}

				isInList = true;

				return false;
			});
			if (!isInList) {
				fileterList.unshift(insertItem);
			}

			setLocalStorage(this.getUserHistoryKey(), fileterList);
		}
	}

	/** 保存用户选择记录数组 */
	public saveUserSelectedSceneModelHistory(sceneSelectData: any, modelSelectData: any, businessSelectData: any = {}): void {
		// console.log('sceneSelectData...', sceneSelectData, modelSelectData, businessSelectData);
		if (modelSelectData.modelCode === SceneConstType.MODEL_BUBUY) {
			// CSIG不记录
			return;
		}

		// 获取用户记录
		const historyList: Array<any> = getLocalStorage(this.getUserHistoryKey()) || [];
		if (historyList) {
			const insertItem: any = {
				scene: sceneSelectData?.sceneCode || SceneConstType.SCENE_QCP,
				model: modelSelectData || SceneConstType.MODEL_CDP,
				businessLine: businessSelectData.modelCode
			};
			const fileterList: Array<any> = historyList.filter((item: any): any => {
				if (item.model.modelName !== insertItem.model.modelName) {
					return true;
				}

				return false;
			});

			fileterList.unshift(insertItem);

			setLocalStorage(this.getUserHistoryKey(), fileterList);
		}
	}

	/** 存储当前现在场景 */
	public saveCurrentSeletedSceneMode(selectSceneData: any): void {
		setLocalStorage(this.getUserCurrentSelectKey(), selectSceneData);
	}

	/** 删除本地缓存的常用场景 */
	public deleteUserSelectedSceneModelHistory(sceneSelectData: ISceneOption | undefined, modelSelectData: IModelOption | undefined = {}): void {
		// 获取用户记录
		const historyList: Array<any> = getLocalStorage(this.getUserHistoryKey()) || [];
		if (historyList) {
			const insertItem: any = {
				scene: sceneSelectData?.sceneCode || SceneConstType.SCENE_QCP,
				model: modelSelectData || SceneConstType.MODEL_CDP
			};
			const fileterList: Array<any> = historyList.filter((item: any): any => {
				if (item.model.modelName !== insertItem.model.modelName) {
					return true;
				}

				return false;
			});

			setLocalStorage(this.getUserHistoryKey(), fileterList);
		}
	}

	/** 计算选中内容提示文本 */
	public updateSelectedTips(sceneSelectData: ISceneOption | undefined, modelSelectData: IModelOption | undefined): string {
		let result: string = '当前场景: ';

		if (sceneSelectData && sceneSelectData.sceneName) {
			result += `${sceneSelectData.sceneName}-${sceneSelectData.sceneCode}`;

			if (modelSelectData && modelSelectData.modelName) {
				result += ` 模式: ${modelSelectData.modelName}`;
			} else {
				result += ' 模式: 无';
			}
		}

		return result;
	}
}
